
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"10","viewBox":"0 0 9 10","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.8333 4.33338H2.7733L4.97331 2.14004C5.09884 2.01451 5.16937 1.84424 5.16937 1.66671C5.16937 1.48917 5.09884 1.31891 4.97331 1.19338C4.84777 1.06784 4.67751 0.997314 4.49997 0.997314C4.32244 0.997314 4.15217 1.06784 4.02664 1.19338L0.693305 4.52671C0.632611 4.59011 0.585034 4.66487 0.553305 4.74671C0.486626 4.90902 0.486626 5.09107 0.553305 5.25338C0.585034 5.33521 0.632611 5.40997 0.693305 5.47337L4.02664 8.80671C4.08861 8.86919 4.16235 8.91879 4.24359 8.95264C4.32483 8.98648 4.41196 9.00391 4.49997 9.00391C4.58798 9.00391 4.67512 8.98648 4.75636 8.95264C4.8376 8.91879 4.91133 8.86919 4.97331 8.80671C5.03579 8.74473 5.08539 8.671 5.11923 8.58976C5.15308 8.50852 5.1705 8.42138 5.1705 8.33337C5.1705 8.24537 5.15308 8.15823 5.11923 8.07699C5.08539 7.99575 5.03579 7.92202 4.97331 7.86004L2.7733 5.66671H7.8333C8.01012 5.66671 8.17969 5.59647 8.30471 5.47145C8.42973 5.34642 8.49997 5.17685 8.49997 5.00004C8.49997 4.82323 8.42973 4.65366 8.30471 4.52864C8.17969 4.40361 8.01012 4.33338 7.8333 4.33338Z","fill":"#161A21"}})])
          )
        }
      }
    